"use strict";

exports.__esModule = true;
exports.AggregateMeasureTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _AggregateTimelineMetrics = require("../../Metrics/MetricQueryController/AggregateTimelineMetrics");
var _getTimelineAggregateQuery = require("../AggregateMeasureChart/getTimelineAggregateQuery");
var _TimeContext = require("../../Time/TimeContext");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
var _RenderMeasureTable = require("./RenderMeasureTable");
var _errorHandler = require("./errorHandler");
var _MaxBinLimitWrapper = require("../common/MaxBinLimitWrapper");
var _aggregateMeasureTableHelpers = require("./aggregateMeasureTableHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getAggregationName = function getAggregationName(fieldName) {
  return fieldName.replace(".", "-");
};
var AggregateMeasureTable = exports.AggregateMeasureTable = function AggregateMeasureTable(props) {
  var dataSource = props.dataSource,
    dataRange = props.dataRange,
    tableProps = props.tableProps,
    pagination = props.pagination,
    measureColumnIds = props.measureColumnIds,
    dimensionColumnIds = props.dimensionColumnIds,
    width = props.width,
    height = props.height,
    windowType = props.windowType,
    columns = props.columns;
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var timePeriod = (0, _TimePeriodController.useSelectionContext)({
    dataRange: dataRange
  });
  var device = (0, _SelectedDevicesController.useSelectedDevices)();
  var query = (0, _getTimelineAggregateQuery.getTimelineAggregateQuery)({
    device: device,
    interval: timePeriod.interval,
    measureColumnIds: measureColumnIds,
    dimensionColumnIds: dimensionColumnIds,
    windowType: windowType,
    timezoneName: time.timezone.name,
    type: [dataSource],
    getAggregationName: getAggregationName
  });
  return /*#__PURE__*/_react["default"].createElement(_MaxBinLimitWrapper.MaxBinLimitWrapper, {
    timeAggregationName: windowType
  }, /*#__PURE__*/_react["default"].createElement(_AggregateTimelineMetrics.AggregateTimelineMetricQueryController, {
    query: query
  }, function (_ref) {
    var error = _ref.error,
      data = _ref.data,
      reload = _ref.reload,
      fetching = _ref.fetching;
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_errorHandler.HandleQueryError, {
        width: width,
        height: height,
        error: error
      });
    }
    var measuresData = (0, _aggregateMeasureTableHelpers.getAggregatedMeasuresData)(data, {
      time: time,
      windowType: windowType
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "aggregate-measure-table-element-with-data"
    }, /*#__PURE__*/_react["default"].createElement(_RenderMeasureTable.RenderMeasureTable, _extends({}, tableProps, {
      columns: columns,
      data: measuresData,
      pages: Math.ceil(measuresData.length / pagination.pageSize),
      loading: fetching,
      reload: reload
    })));
  }));
};